import { Progress } from '@ant-design/charts';
import { Col, Row, Skeleton, Typography } from 'antd';
import { withTranslation } from 'react-i18next';
import './styles.less';

const { Text } = Typography;

function ValidSignSignatureCounter({
  t,
  percentage,
  overviewIsLoaded,
  signatureStarted,
  maxSignature,
}) {
  const getRangeColor = () => {
    const GREEN = '#52C41A';
    const ORANGE = '#FAAD14';
    const RED = '#FF4D4F';

    if (percentage > 0 && percentage <= 0.4) return GREEN;
    else if (percentage > 0.4 && percentage <= 0.7) return ORANGE;
    else return RED;
  };

  const progressConfig = {
    height: 50,
    width: 300,
    autoFit: false,
    barWidthRatio: 0.5,
    percent: percentage,
    color: [getRangeColor(), '#E8EDF3'],
  };

  return (
    <div className="validSignSignatureCounter">
      {overviewIsLoaded ? (
        signatureStarted === 0 && maxSignature === 0 ? (
          <Row align="middle" gutter={32}>
            <Col>
              <Text type="warning">
                {t('PageContainer.Validsign.Overview.NoSignatureAvailable')}
              </Text>
            </Col>
          </Row>
        ) : (
          <>
            <Row align="middle" gutter={32}>
              <Col>
                <span className="validSignSignatureCounter-value">
                  {signatureStarted || 'N/D'}{' '}
                </span>
                <span style={{ color: getRangeColor() }}>
                  {t(
                    'PageContainer.Validsign.Overview.CompanyInfo.SignatureStarted'
                  )}
                </span>
              </Col>
              <Col>
                <span className="validSignSignatureCounter-value">
                  {maxSignature || 'N/D'}{' '}
                </span>
                <span style={{ color: '#b7b7b7' }}>
                  {t(
                    'PageContainer.Validsign.Overview.CompanyInfo.MaxNumberOfSignature'
                  )}
                </span>
              </Col>
            </Row>
            <Progress {...progressConfig} />
          </>
        )
      ) : (
        <Skeleton active />
      )}
    </div>
  );
}

export default withTranslation()(ValidSignSignatureCounter);
